import InputCus from "../../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  ProductCreateSeriesEnd,
  ProductFilterSeriesEnd,
  ProductUpdateSeriesEnd,
} from "../../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function SeriesEndAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const FilterSeriesEndDataData = await ProductFilterSeriesEnd({
          id: id,
        });
        if (FilterSeriesEndDataData.status && FilterSeriesEndDataData.status === 200) {
          setForm(FilterSeriesEndDataData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const UpdateSeriesEndData = await ProductUpdateSeriesEnd(form);
          if (UpdateSeriesEndData.status && UpdateSeriesEndData.status === 200) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Products/SeriesEnd");
          }
        } else {
          const CreateSeriesEndData = await ProductCreateSeriesEnd(form);
          if (CreateSeriesEndData.status && CreateSeriesEndData.status === 200) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Products/SeriesEnd");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-column w-100">
              <InputCus
                SeriesEnd="text"
                className="m-2"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SeriesEndAE;
